var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.viewOnly)?_c('div',{staticClass:"form-group"},[_vm._v(" "+_vm._s(_vm.getValue())+" ")]):_c('custom-password-input',{attrs:{"value":_vm.getValue()},on:{"input":_vm.input}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }